<template>
  <a :href="href" target="_blank" :class="{ 'text-body text-decoration-none': true, 'media': hasDescription }">
    <span :class="{ 'align-self-center': true, 'media-left mr-3': hasDescription }">
      <span class="position-relative d-block thumbnail">
        <img :src="thumbnailSrc" :width="width">
        <span
          class="play d-block d-flex align-items-center justify-content-center"
          :style="`width:${buttonWidth}px; height:${buttonHeight}px;`">
          <i class="fa fa-play" />
        </span>
      </span>
      <small class="title d-block mt-2" v-if="externalTitle" :style="`width:${width}px`">
        {{ externalTitle }}
      </small>
    </span>
    <small class="media-body align-self-top">
      <slot>
        <span :description="externalDescription"></span>
      </slot>
    </small>

  </a>
</template>

<style lang="scss" scoped>
.thumbnail {
  background-color: #efefef;
}
.play {
  position: absolute;
  background-color: rgba(189, 175, 138, 0.75);
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  .fa-play {
    color: rgba(255, 255, 255, 0.95);
  }
}

a:hover {
  .play {
    background-color: rgba(189, 175, 138, 0.60);
  }
}
</style>

<script>
import $ from 'jquery'
import { embed } from '@/api'

export default {
  props: {
    href: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      default: 100
    },
    thumbnail: {
      type: String,
      default: null
    },
    description: {
      type: [String, Boolean],
      default: null
    },
    title: {
      type: [String, Boolean],
      default: null
    }
  },
  computed: {
    hasDescription () {
      return this.description !== false && (this.externalDescription || this.$slots.default)
    },
    hasTitle () {
      return this.title !== false && this.externalTitle
    },
    height () {
      return this.width * this.aspectRatio
    },
    buttonWidth () {
      return Math.max(50, this.width / 7)
    },
    buttonHeight () {
      return this.buttonWidth * this.aspectRatio
    }
  },
  watch: {
    height () {
      $(this.$el).find('.thumbnail').height(this.height)
    }
  },
  data () {
    return {
      aspectRatio: 0.5625,
      thumbnailSrc: this.thumbnail,
      externalDescription: this.description !== false ? this.description : null,
      externalTitle: this.title !== false ? this.title : null
    }
  },
  async mounted () {
    $(this.$el).find('.thumbnail').height(this.width * 0.5625)
    const { data } = await embed(this.href)
    if (data.aspectRatio) {
      this.aspectRatio = data.aspectRatio > 1 ? data.aspectRatio / 100 : data.aspectRatio
    } else {
      this.aspectRatio = data.imageWidth / data.imageHeight
    }
    if (this.externalDescription !== false) {
      this.externalDescription = data.description
    }
    if (this.externalTitle !== false) {
      this.externalTitle = data.title
    }
    if (!this.thumbnail) {
      this.thumbnailSrc = data.image
    }
  }
}
</script>
